const API_URL = 'https://www.barcodepapel.pt:5017/api/auth';

class AuthService {
  async register(email, password, isPublicProfile = true) {
    try {
      const response = await fetch(`${API_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
          isPublicProfile
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao registrar');
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify({
        email: data.email,
        nome: data.nome
      }));

      return data;
    } catch (error) {
      console.error('Erro no registro:', error);
      throw error;
    }
  }

  async login(email, password) {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password
        })
      });

      const data = await response.json();
      console.log(data)

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao fazer login');
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify({
        email: data.email,
        nome: data.nome,
        isAdmin: data.isAdmin || false
      }));

      return data;
    } catch (error) {
      console.error('Erro no login:', error);
      throw error;
    }
  }

  async socialLogin(provider, token, email, nome, providerId) {
    try {
      const response = await fetch(`${API_URL}/social-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          provider,
          token,
          email,
          nome,
          providerId
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao fazer login social');
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify({
        email: data.email,
        nome: data.nome
      }));

      return data;
    } catch (error) {
      console.error('Erro no login social:', error);
      throw error;
    }
  }

  async getCurrentUser() {
    try {
      const token = this.getToken();

      if (!token) {
        return null;
      }

      const response = await fetch(`${API_URL}/me`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        this.logout();
        return null;
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar usuário:', error);
      this.logout();
      return null;
    }
  }

  async validateRegistrationToken(token) {
    try {
      const response = await fetch(`${API_URL}/validate-registration-token?token=${token}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) return { valid: false };
      return await response.json();
    } catch (error) {
      console.error('Erro ao validar token:', error);
      return { valid: false };
    }
  }

  async completeRegistration(registrationData) {
    try {
      const response = await fetch(`${API_URL}/complete-registration`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(registrationData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao completar registo');
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      return data;
    } catch (error) {
      console.error('Erro ao completar registo:', error);
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  getToken() {
    return localStorage.getItem('token');
  }

  getUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }

  isAuthenticated() {
    return !!this.getToken();
  }
}

export default new AuthService();